import { apiInterfaceForJson } from "../common/apiManager";

export const searchDashboard = (query) => {
    return apiInterfaceForJson("/dashboard/v1/search", "POST", query);
};
